import Axios from 'axios'
import {userUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_users (context) {
    Axios.get(userUrls.getAllUsers).then(function (response) {
      context.commit('GET_ALL_USERS', response.data)
    })
  },
  get_more_users (context, page) {
    Axios.get(userUrls.getAllUsers + "?page=" + page + "&items=15").then(function (response) {
      context.commit('GET_MORE_USERS', response.data)
    })
  },
  get_institution_users (context, publicId) {
    Axios.get(userUrls.getUsers + publicId).then(function (response) {
      context.commit('GET_USERS', response.data)
    })
  },
  get_institution_users2 (context, publicId) {
    Axios.get(userUrls.getUsers + publicId).then(function (response) {
      context.commit('GET_ALL_USERS', response.data)
    })
  },
  get_deleted_users (context) {
    Axios.get(userUrls.getDeletedUser).then(function (response) {
      context.commit('GET_DELETED_USERS', response.data)
    })
  },
  suspend_user (context, publicId) {
    Axios.get(userUrls.suspendUser + publicId).then(function (response) {
      router.push({
        name: 'Users'
      })
    })
  },
  unsuspend_user (context, publicId) {
    Axios.get(userUrls.unsuspendUser + publicId).then(function (response) {
      router.push({
        name: 'Users'
      })
    })
  },
  get_user(context, publicId) {
  return Axios.get(userUrls.getUser + publicId).then(function(response) {
    context.commit('GET_USER', response.data)
    return response.data  
  })
},
  get_user_by_email (context, email) {
    return Axios.get(userUrls.getUserByEmail + email).then(function (response) {
      context.commit('GET_USER', response.data)
      return response.data
    }).catch(function(error) {
      console.error('Error fetching user by email:', error)
      throw error
    })
  },
  post_partner_user (context, data) {
    Axios.post(userUrls.postPartnerUser, data).then(function () {
      context.dispatch('get_all_users')
      router.push({
        name: 'Users'
      })
    }).catch(function (error) {
    })
  },
  post_user (context, data) {
    Axios.post(userUrls.postUser, data).then(function () {
      context.dispatch('get_all_users')
      router.push({
        name: 'Users'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  post_user_guest (context, data) {
    return new Promise((resolve, reject) => {
      Axios.post(userUrls.postGuestUser, data)
        .then(function (response) {
          if (response.data.access_token) {
            localStorage.setItem('auth_token', response.data.access_token);
            localStorage.setItem('user_data', JSON.stringify(response.data.user));
            Axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
          }
          
          if (response.data.user) {
            context.commit('SET_CURRENT_USER', response.data.user);
          }
          
          if (response.data.message) {
            console.log(response.data.message);
          }
          
          resolve(response.data);
        })
        .catch(function (error) {
          let errorMessage = 'Guest registration failed';
          
          if (error.response) {
            if (error.response.data && error.response.data.message) {
              errorMessage = error.response.data.message;
            }
            context.commit('UPDATE_ERRORS', error.response.data);
            reject(error.response.data);
          } else if (error.request) {
            errorMessage = 'No response from server';
            reject({ message: errorMessage });
          } else {
            errorMessage = error.message;
            reject({ message: errorMessage });
          }
        });
    });
  },
  update_user (context, data) {
    Axios.post(userUrls.editUser + data.public_id, data).then(function () {
      context.dispatch('get_user', data.public_id)
    }).catch(function (error) {
    })
  },
  delete_user (context, publicId) {
    Axios.get(userUrls.deleteUser + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_USERS', response.data)
      router.push({
        name: 'Module.DeletedUsers'
      })
    })
  },
  restoreUser (context, publicId) {
    Axios.get(userUrls.restoreUser + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_USERS', response.data)
      router.push({
        name: 'Module.Users'
      })
    })
  },

  get_wallet_balance (context, userPublicId) {
    return Axios.get(userUrls.getWalletBalance + userPublicId).then(function (response) {
      context.commit('GET_WALLET_BALANCE', response.data)
      return response.data
    }).catch(function (error) {
      console.error('Error fetching wallet balance:', error)
      throw error
    })
  },

get_wallet_transactions(context, userPublicId) {
  return Axios.get(userUrls.getWalletTransactions + userPublicId + "?page=1&items=15").then(function(response) {
    context.commit('GET_WALLET_TRANSACTIONS', response.data)
    return response.data
  }).catch(function(error) {
    console.error('Error fetching transactions:', error)
    throw error
  })
},

get_more_wallet_transactions(context, { userPublicId, page }) {
  const url = userUrls.getWalletTransactions + userPublicId + "?page=" + page + "&items=15"
  return Axios.get(url).then(function(response) {
    context.commit('GET_MORE_WALLET_TRANSACTIONS', response.data)
    return response.data
  }).catch(function(error) {
    console.error('Error fetching more transactions:', error)
    throw error
  })
},

get_all_wallet_transactions(context, userPublicId) {
  const url = userUrls.getWalletTransactions + userPublicId + "?page=0&items=15"
  return Axios.get(url).then(function(response) {
    context.commit('GET_ALL_WALLET_TRANSACTIONS', response.data)
    return response.data
  }).catch(function(error) {
    console.error('Error fetching all transactions:', error)
    throw error
  })
},

  deposit_to_wallet (context, data) {
    return Axios.post(userUrls.walletDeposit, data).then(function (response) {
      if (response.data.status === 'success') {
        context.dispatch('get_wallet_balance', data.user_public_id)
        context.dispatch('get_wallet_transactions', data.user_public_id)
      }
      return response.data
    }).catch(function (error) {
      console.error('Deposit error:', error)
      throw error
    })
  },

  process_mpesa_payment(context, data) {
    console.log('M-Pesa Vuex action received:', data) 
    
    const requestData = {
      phone: data.phone,  
      user_public_id: data.user_public_id,  
      currency_public_id: data.currency_public_id,
      reference: data.reference,  
      description: data.description,  
      booking_id: data.reference,
      amount: data.amount,
      session_id: 'wallet_deposit',
      public_donations: []
    }
    
    console.log('Sending to backend:', requestData)
    
    return Axios.post(userUrls.mpesaPayment, requestData)
      .then(function(response) {
        console.log('M-Pesa response:', response.data)
        if (response.data.status === 'success') {
          return response.data
        }
        return response.data
      })
      .catch(function(error) {
        console.error('M-Pesa payment error:', error)
        throw error
      })
  },
  
  check_mpesa_payment_status (context, checkoutRequestId) {
    return Axios.get(userUrls.mpesaStatus + checkoutRequestId).then(function (response) {
      return response.data
    }).catch(function (error) {
      console.error('Error checking M-Pesa status:', error)
      throw error
    })
  },
  
  process_card_payment (context, data) {
    return Axios.post(userUrls.iveriPayment, {
      booking_id: data.reference,
      amount: data.amount,
      currency_public_id: data.currency_public_id,
      email: localStorage.getItem('user_email') || '',
      card_data: data.card_data
    }).then(function (response) {
      if (response.data.status === 'success') {
        if (response.data.data && response.data.data.redirect_url) {
          window.location.href = response.data.data.redirect_url
        }
        return response.data
      }
      return response.data
    }).catch(function (error) {
      console.error('Card payment error:', error)
      throw error
    })
  },
  
  process_iveri_donation (context, data) {
    return Axios.post(userUrls.iveriDonation, {
      public_donations: data.donations,
      booking_id: data.booking_id
    }).then(function (response) {
      return response.data
    }).catch(function (error) {
      console.error('iVeri donation error:', error)
      throw error
    })
  },

  pay_from_wallet (context, data) {
    return Axios.post(userUrls.walletPayment, data).then(function (response) {
      if (response.data.status === 'success') {
        context.dispatch('get_wallet_balance', data.user_public_id)
        context.dispatch('get_wallet_transactions', data.user_public_id)
      }
      return response.data
    }).catch(function (error) {
      console.error('Payment error:', error)
      throw error
    })
  },

  refund_to_wallet (context, data) {
    return Axios.post(userUrls.walletRefund, data).then(function (response) {
      if (response.data.status === 'success') {
        context.dispatch('get_wallet_balance', data.user_public_id)
        context.dispatch('get_wallet_transactions', data.user_public_id)
      }
      return response.data
    }).catch(function (error) {
      console.error('Refund error:', error)
      throw error
    })
  },

  get_wallet_transaction_by_reference (context, reference) {
    return Axios.get(userUrls.getWalletTransaction + reference).then(function (response) {
      context.commit('GET_WALLET_TRANSACTION', response.data)
      return response.data
    }).catch(function (error) {
      console.error('Error fetching transaction:', error)
      throw error
    })
  },

  get_booking_wallet_transactions (context, bookingId) {
    return Axios.get(userUrls.getBookingWalletTransactions + bookingId).then(function (response) {
      context.commit('GET_BOOKING_WALLET_TRANSACTIONS', response.data)
      return response.data
    }).catch(function (error) {
      console.error('Error fetching booking transactions:', error)
      throw error
    })
  },

  get_user_deposits (context, { userPublicId, currencyPublicId }) {
    let url = userUrls.getUserWalletDeposits + userPublicId
    if (currencyPublicId) {
      url = url + "?currency_public_id=" + currencyPublicId
    }
    return Axios.get(url).then(function (response) {
      context.commit('GET_USER_DEPOSITS', response.data)
      return response.data
    }).catch(function (error) {
      console.error('Error fetching deposits:', error)
      throw error
    })
  },

  initiate_bank_transfer (context, data) {
    return new Promise(function(resolve) {
      resolve({
        status: 'success',
        data: {
          bank_name: 'KCB Bank Kenya',
          account_name: 'Ol Pejeta Conservancy',
          account_number: '1234567890',
          branch: 'Nairobi CBD',
          swift_code: 'KCBLKENX'
        }
      })
    })
  },

  reset_wallet_state (context) {
    context.commit('RESET_WALLET_STATE')
  }
}